import { BASE_URL } from 'configs';
import request from 'utils/axios';
import { User, InviteUserPayload } from './types';

export const USERS_URL = `${BASE_URL}/api/users`;

/** Admin-only. GET /api/users returns the full, unpaginated user list. */
export const getUsersList = (): Promise<User[]> => request(USERS_URL, { method: 'GET', includeAuth: true });

export const inviteUser = (payload: InviteUserPayload): Promise<User> =>
  request(`${USERS_URL}/invite`, { method: 'POST', includeAuth: true, data: payload });

export const deactivateUser = (userId: string): Promise<User> =>
  request(`${USERS_URL}/${userId}/deactivate`, { method: 'PATCH', includeAuth: true });
